import { ENV } from '@/lib/config/env';

if (!ENV.PLATFORM_API_BASE_URL) {
  throw new Error('PLATFORM_API_BASE_URL environment variable is not set');
}

export { assetsHttp } from './assets-client';
export { inferenceHttp } from './inference-client';
export { workspaceHttp } from './workspace-client';
export { mediaHttp } from './media-client';
export { contentStudioHttp } from './content-studio-client';
export { reelsHttp } from './reels-client';
